import {
	errorColor,
	primaryColor,
	successColor,
	warningColor,
} from "../../core/theme";
import { ChangeRequestStatus } from "../../requests_cm/gepoChangeRequestService/types";
import { ContractStatus } from "../../requests_cm/gecoContractsService/types";

export function getContractStatusColor(
	status?: ChangeRequestStatus | ContractStatus
) {
	switch (status) {
		case ChangeRequestStatus.REJECTED:
			return errorColor;
		case ChangeRequestStatus.PENDING:
			return warningColor;
		case ContractStatus.VALID:
			return successColor;
		default:
			return primaryColor;
	}
}

export function getValidationButtonColor(
	status?: ChangeRequestStatus | ContractStatus
) {
	switch (status) {
		case ChangeRequestStatus.REJECTED:
			return "destructive";
		case ChangeRequestStatus.PENDING:
			return "primary";
		case ContractStatus.VALID:
			return "secondary";
		default:
			return "primary";
	}
}

export function getContractStatusText(
	status?: ChangeRequestStatus | ContractStatus
): string {
	switch (status) {
		case ContractStatus.VALID:
			return "Valid";
		case ContractStatus.TO_REVIEW:
			return "To Review";
		case ContractStatus.DRAFT:
			return "Draft";
		case ChangeRequestStatus.PENDING:
			return "Waiting trader approval";
		case ChangeRequestStatus.VALID:
			return "Trader applied changes";
		case ChangeRequestStatus.REJECTED:
			return "Trader rejected changes";
		default:
			return "";
	}
}

export function getValidationButtonText(
	status?: ChangeRequestStatus | ContractStatus
): string {
	switch (status) {
		case ContractStatus.VALID:
			return "Review Validation";
		case ContractStatus.TO_REVIEW:
			return "Review contract";
		case ContractStatus.DRAFT:
			return "Draft";
		case ChangeRequestStatus.PENDING:
			return "Review changes";
		case ChangeRequestStatus.VALID:
			return "Validate contract";
		case ChangeRequestStatus.REJECTED:
			return "Review trader comments";
		default:
			return "";
	}
}

export function jsonStringToObjectString(jsonString: string) {
	try {
		const jsonObject = JSON.parse(jsonString);
		const formattedObjectString = JSON.stringify(jsonObject, null, 2);
		return "`\n" + formattedObjectString + "\n`";
	} catch (error) {
		console.error("Error parsing JSON:", error);
		return "";
	}
}
